interface Error {
  [index: string]: string;
}

const ERRORS: Error = {
  LOGIN_FAILED: "ไม่สามารถเข้าสู่ระบบ โปรดตรวจสอบชื่อผู้ใช้และรหัสผ่าน",
  LEAVE_TICKET_WAS_CANCELED: "ใบลานี้ยกเลิกสำเร็จไปแล้ว",
  LEAVE_TICKET_CANCEL_REQUEST_UNDER_PROCESSING:
    "ใบลานี้มีคำขอยกเลิกที่อยู่ระหว่างดำเนินการ หากต้องการดำเนินการใด ๆ กับใบลานี้ให้ติดต่อผู้ดูแลระบบ",
  LEAVE_TICKET_WAS_APPROVED_CANNOT_CANCEL_BY_USER:
    "ใบลานี้ได้รับการอนุมัติแล้ว ต้องส่งคำขอยกเลิกเท่านั้น",
  LEAVE_TICKET_WAS_REJECTED_CANNOT_CANCEL_BY_USER:
    "ใบลานี้ได้รับการปฏิเสธแล้ว ไม่สามารถยกเลิกได้",
  LEAVE_TICKET_WAS_RECEIVED_BY_ADMIN_CANNOT_CANCEL:
    "ใบลานี้มีเจ้าหน้าที่รับข้อมูลไปแล้ว หากต้องการยกเลิกโปรดส่งคำขอยกเลิกใบลา",
  LEAVE_TICKET_DATE_INVALID: "ช่วงวันที่ต้องการลาไม่ถูกต้อง",
  LEAVE_TICKET_OVERLAP: "ใบลานี้มีช่วงวันลาทับซ้อนกับใบลาอื่น",
  LEAVE_TICKET_NO_EFFECTIVE_DATE: "ช่วงวันที่เลือกไม่อยู่ในวันทำการใด ๆ",
  LEAVE_TICKET_WAS_APPROVED_CANNOT_REJECT:
    "ใบลานี้อนุมัติไปแล้ว ไม่สามารถยกเลิกได้ ต้องส่งคำร้องขอยกเลิกเท่านั้น",
  LEAVE_TICKET_CANCEL_REQUEST_ALREADY_APPROVED: "ใบลานี้ยกเลิกสำเร็จไปแล้ว",
  ATTENDANCE_STATUS_EDIT_CANNOT_CHANGE_TO_LEAVE:
    "ไม่สามารถเปลี่ยนสถานะเป็นลาได้ โปรดใช้วิธีส่งใบลา",
  ATTENDANCE_STATUS_EDIT_CANNOT_CHANGE_FROM_LEAVE:
    "ไม่สามารถเปลี่ยนสถานะจากลาเป็นอย่างอื่นได้ โปรดใช้วิธียกเลิกใบลา",
  DEPARTMENT_NAME_EXIST: "มีสังกัดที่ใช้ชื่อนี้ไปแล้ว",
  LINE_API_ERROR: "ไม่สามารถติดต่อระบบของไลน์ได้ โปรดลองใหม่ในอีกสักครู่",
};

export default ERRORS;
